"use client";
import React from "react";
import { usePathname } from "@/i18n/navigation";
import FileAgeCalc from "./fileAgeCalc/FileAgeCalc";
import BMICalculator from "./fileBMICalculator/BMICalculator";
import CgpaToPerc from "./fileCGPAtoPerCalc/CgpaToPerc";
import LogCalculator from "./fileLogCalc/LogCalculator";
import FileGstCalc from "./fileGstCalc/FileGstCalc";
import FileLoanCalc from "./fileLoanCalc/FileLoanCalc";
import FilePercentageCalc from "./filePercentageCalc/FilePercentageCalc";
import FileSalaryCalc from "./fileSalaryCalc/FileSalaryCalc";
import TimeSheetCal from "./fileTimeSeetCalc/TimeSheetCal";
import MortgageCalculator from "./mortgageCalculator/MortgageCalculator";
import SassProductCalc from "./saasProductCalc/SassProductCalc";
import FullScreenCalculator from "./fullScreenCalculator/FullScreenCalculator";
import ScientificCalculator from "./scientificCalculator/ScientificCalculator";
import { ParaData } from "../common/CommonArray/FileArray";
import { HowToUseText } from "@/common/ToolPara";
import { useSearchParams } from "next/navigation";

const routeConfig = {
  "/age-calculator": {
    toolName: "Age Calculator",
    paraData: ParaData.AGE_CALCULATOR,
  },
  "/bmi-calculator": {
    toolName: "BMI Calculator",
    paraData: ParaData.BMI_CALCULATOR,
  },
  "/log(logarithm)-calculator": {
    toolName: "Logarithm Calculator",
    paraData: ParaData.LOG_CALCULATOR,
  },
  "/gst-calculator": {
    toolName: "GST Calculator",
    paraData: ParaData.GST_CALCULATOR,
  },
  "/loan-calculator": {
    toolName: "Loan Calculator",
    paraData: ParaData.LOAN_CALCULATOR,
  },
  "/percentage-calculator": {
    toolName: "Percentage Calculator",
    paraData: ParaData.PERCENTAGE_CALCULATOR,
  },
  "/salary-calculator": {
    toolName: "Salary Calculator",
    paraData: ParaData.SALARY_CALCULATOR,
  },
  "/timesheet-calculator": {
    toolName: "Timesheet Calculator",
    paraData: ParaData.TIMESHEET_CALCULATOR,
  },
  "/cpi-cgpa-to-percentage-calculator": {
    toolName: "CPI/CGPA to Percentage Calculator",
    paraData: ParaData.CGPA_TO_PERCENTAGE,
  },
  "/mortgage-calculator": {
    toolName: "Mortgage Calculator",
    paraData: ParaData.MORTGAGE_CALCULATOR,
  },
  "/saas-product-calculator": {
    toolName: "SaaS Product Calculator",
    paraData: ParaData.SAAS_PRODUCT_CALCULATOR,
  },
  "/full-screen-calculator": {
    toolName: "Full Screen Calculator",
    paraData: ParaData.FULL_SCREEN_CALCULATOR,
  },
  "/scientific-calculator": {
    toolName: "Scientific Calculator",
    paraData: ParaData.SCIENTIFIC_CALCULATOR,
  },
};
function CalculatorToolsData() {
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const currentRoute = routeConfig[pathName];
  const isFullScreenCalc =
    (pathName === "/full-screen-calculator" || pathName === "/scientific-calculator") &&
    searchParams.get("fullscreen") === "1";

  return (
    <>
      {pathName === "/age-calculator" && <FileAgeCalc />}
      {pathName === "/bmi-calculator" && <BMICalculator />}
      {pathName === "/log(logarithm)-calculator" && <LogCalculator />}
      {pathName === "/gst-calculator" && <FileGstCalc />}
      {pathName === "/loan-calculator" && <FileLoanCalc />}
      {pathName === "/percentage-calculator" && <FilePercentageCalc />}
      {pathName === "/salary-calculator" && <FileSalaryCalc />}
      {pathName === "/timesheet-calculator" && <TimeSheetCal />}
      {pathName === "/cpi-cgpa-to-percentage-calculator" && <CgpaToPerc />}
      {pathName === "/mortgage-calculator" && <MortgageCalculator />}
      {pathName === "/saas-product-calculator" && <SassProductCalc />}
      {pathName === "/full-screen-calculator" && <FullScreenCalculator />}
      {pathName === "/scientific-calculator" && <ScientificCalculator />}
      {currentRoute && !isFullScreenCalc && (
        <HowToUseText
          toolName={currentRoute.toolName}
          firstPata={currentRoute.paraData.firstPara}
          secondPara={currentRoute.paraData.secondPara}
          toolData={currentRoute.paraData.toolData}
          howToUse={currentRoute.paraData.howToUse}
          whyUse={currentRoute.paraData.whyUse}
          commonUseCases={currentRoute.paraData.commonUseCases}
          features={currentRoute.paraData.features}
          faq={currentRoute.paraData.faq}
          tips={currentRoute.paraData.tips}
          relatedTools={currentRoute.paraData.relatedTools}
        />
      )}
    </>
  );
}

export default CalculatorToolsData;
